/**
 *
 * ScreenToShowOnPicker
 *
 */

import {
  BaseOptionsPicker,
  BaseOptionsPickerProps,
} from 'app/components/BasicPickers/BaseOptionsPicker';
import { ScreenToShowOn } from 'enums/ScreenToShowOn';
import { Entity } from 'types/common';
import { enumToEntityArray } from 'utils/enumKeys';

export interface ScreenToShowOnPickerProps
  extends Omit<BaseOptionsPickerProps<Entity<number>>, 'getOptions'> {}

export const getSingleScreenToShowOn = (val: number): Entity<number> => {
  return enumToEntityArray(ScreenToShowOn).filter(item => {
    return item.Id === val;
  })[0];
};

export const initScreenToShowOnData = (
  initval: number | undefined,
): Promise<Entity<number>[]> => {
  if (initval === undefined) {
    return new Promise<Entity<number>[]>((resolve, reject) => {
      resolve([] as Entity<number>[]);
    });
  } else {
    return new Promise<Entity<number>[]>((resolve, reject) => {
      resolve([getSingleScreenToShowOn(initval)]);
    });
  }
};

const getOptions = (searchTerm: string | null) => {
  let items = enumToEntityArray(ScreenToShowOn);
  if (searchTerm !== null && searchTerm !== '') {
    return items.filter(
      f => f.Name.startsWith(searchTerm) || f.Name.indexOf(searchTerm) !== -1,
    );
  }
  return items;
};

export function ScreenToShowOnPicker(props: ScreenToShowOnPickerProps) {
  return (
    <BaseOptionsPicker
      mini={props.mini ? true : undefined}
      size={props.size}
      getOptions={getOptions}
      value={props.value}
      style={{ marginRight: '4px' }}
      {...props}
    />
  );
}
